<template>
  <header
    :class="['header', headerConfig.immersion && opacity >= 1 && 'header-scroll']"
    class="header"
    :style="{
      paddingTop: px2rem(viewPaddingTop),
      height: px2rem(viewPaddingTop + 44),
      backgroundColor: `rgba(255, 255, 255,
      ${headerOpacity})`,
    }"
  >
    <div class="header-container">
      <div class="header-left" >
        <span
          class="back-icon icon"
          :style="{
            backgroundImage: `url(${back[iconStatus]})`
          }"
          @click="goBack"
        />
      </div>
      <div class="header-center" :style="{ opacity: headerOpacity }">
        <div class="header-center-title">
          {{ headerConfig.title }}
        </div>
      </div>
      <div class="header-right">
        <span
          class="icon"
          @click="goShare"
          v-if="headerConfig.showShare && (env.inAPP || isMock)"
          :style="{
            backgroundImage: `url(${share[iconStatus]})`
          }"
        />
        <span
          class="icon"
          v-for="(icon, i) in headerConfig.iconList"
          :key="i"
          :style="{
            backgroundImage: `url(${icon[iconStatus]})`
          }"
          @click="onClickCustomIcon(icon)"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { env } from '@/config';
import { openUrl } from '@/utils/utils';

export default {
  name: 'header',
  props: {
    headerConfig: {
      type: Object
    },
    shareData: {
      type: Object,
      default: () => ({})
    },
    customBack: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 0
    },
    shareConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isMock: env === 'mock',
      iconStatus: 'light',
      back: {
        light: require('@/assets/back-light-icon.png'),
        dark: require('@/assets/back-dark-icon.png')
      },
      share: {
        light: require('@/assets/share-light-icon.png'),
        dark: require('@/assets/share-dark-icon.png')
      }
    };
  },
  computed: {
    headerOpacity() {
      return this.headerConfig.immersion ? this.opacity : 1;
    },
    viewPaddingTop() {
      return this.adapt.getPaddingTop();
    }
  },
  watch: {
    headerOpacity(val) {
      // 设置图标状态
      this.getIconStatus(val);
    }
  },
  created() {
    // 在app中且选择显示自定义导航栏，隐藏原生导航栏
    if (this.env.inAPP) {
      this.adapt.hideNavBar();
    }
  },
  mounted() {
    this.getIconStatus(this.headerOpacity);
  },
  methods: {
    getIconStatus(val) {
      this.iconStatus = val >= 1 ? 'dark' : 'light';
    },
    goBack() {
      if (this.customBack) {
        // 自定义后退
        this.$emit('goBack');
        return;
      }

      this.$goBack()
    },
    goShare() {
      const shareData = { ...this.shareData, desc: this.shareData.content };
      delete shareData.content;
      Sailer.openShare(shareData);
    },
    onClickCustomIcon(icon) {
      if (icon.url) openUrl(icon.url);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100vw;
  position: fixed;
  z-index: 99;
  .header-container {
    display: flex;
    align-items: center;
    font-size: 18px;
    height: 100%;
    .icon {
      width: 24px;
      height: 24px;
      display: block;
      background-size: cover;
    }
    .header-left {
      flex: 1;

      .back-icon {
        margin-left: 12px;
      }
    }
    .header-center {
      display: flex;
      justify-content: center;
      align-items: center;
      .header-center-title {
        width: 150px;
        height: 18px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262626;
        line-height: 18px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

    }
    .header-right {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      line-height: 12px;
      .icon {
        width: 24px;
        height: 24px;
        display: block;
        background-size: cover;
        margin-right: 12px;
      }
    }
  }
}

</style>
